

function IconText({ d, textX, textY, textOpacity, fontSize }) {

  const iconText = d['oorzaakeffectimpact_kort'];

  // text if on one line
  let tspan = (
    <text >
      <tspan>{iconText}</tspan>
    </text>
  )
  // text if on two lines
  const iconTextLength = iconText.length;
  if(iconTextLength > 10){
    if(true){
      let textSplit = iconText.split(' ');
      // textSplit = ['Dit', 'is', 'een', 'heel lange', 'test', 'omschrijving']
      let noWordsOnSecondLine = 0;
      let currentLength = 0;
      textSplit.forEach((word, i) => {
        if(currentLength + word.length > iconTextLength/2 - 5){
          noWordsOnSecondLine += 1;
        }
        currentLength += word.length;
      });


      // first line are all words except the last
      const firstLine = textSplit.map((d,i) => {
        if(i < textSplit.length-noWordsOnSecondLine+1){return textSplit[i] + ' ';}
        else{return "";}
      });
      const secondLine = textSplit.slice(textSplit.length-noWordsOnSecondLine+1).map((d,i) => {
        return d + ' ';
      });
      // second line is the last word
      // const secondLine = textSplit.slice(textSplit.length-1);

      tspan = (
        <>
          <text><tspan dy='-0.5em'>{firstLine}</tspan></text>
          <text><tspan dy='0.5em'>{secondLine}</tspan></text>
        </>
      )
    }
  }


  return (
    <g className={"iconText_" + d.typenr}
      transform={`translate(${textX}, ${textY + 10.5})`}
      opacity={textOpacity} textAnchor='middle'
      pointerEvents='none' fontSize={fontSize}>

      <g fill='white' stroke='#f7f7f7' strokeWidth='2'>
        {tspan}
        {tspan}
      </g>
      <g fill='#292929'>
        {tspan}
        {tspan}
      </g>


    </g>

  );


}

export default IconText;
